export default __webpack_public_path__ + "static/media/logo.c8177d3e.png";